module.exports = "https://www.gc-qa.gnp.com.mx/4516941bf3a52d47eb40925df42f790c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-retenciones.svg
// module id = 1838
// module chunks = 0